/**
 * Inne adapter — per-type import adapter for 'inne' media type.
 *
 * Catch-all type for rows that don't fit the other types, including rows
 * migrated from legacy 'other' and 'mpk' enum values.
 *
 * No type-specific required columns — accepts all optional columns from NOSNIKI_HEADERS.
 * Required columns: only COMMON_REQUIRED_COLUMNS.
 */
import type { MediaUnitImportAdapter, ValidationError } from './types.js';
import type { MappedRow } from '../validate-row.js';
import {
  buildBaseRow,
  COMMON_REQUIRED_COLUMNS,
  COMMON_OPTIONAL_COLUMNS,
} from './parse-row.helper.js';

const REQUIRED_COLUMNS = [...COMMON_REQUIRED_COLUMNS, 'Typ nośnika'] as const;

const OPTIONAL_COLUMNS = [
  ...COMMON_OPTIONAL_COLUMNS,
  'Szerokość [m]',
  'Wysokość [m]',
  'Materiał',
  'Oświetlenie',
  '[Mural] Element 3D',
  '[Mural] Taśma LED',
  '[Mural] Neon LED',
  '[Mural] Fluo UV',
  'Multiformat',
  '[Mural] Produkcja eco muralu',
] as const;

export const inneAdapter: MediaUnitImportAdapter = {
  mediaType: 'inne',
  requiredColumns: REQUIRED_COLUMNS,
  optionalColumns: OPTIONAL_COLUMNS,

  validate(_row: MappedRow): ValidationError[] {
    // No type-specific required columns for 'inne'.
    return [];
  },

  parseRow(row: MappedRow) {
    return buildBaseRow(row, 'inne');
  },
};
